define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/api",
	"csi/comm",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml",
	"./AttributeMapMixin"
], function(declare, lang, csi, _, api, comm, Nodes, Widget, xml, AttributeMapMixin) {

	var MODIFIED_ATTR = "Modified";
	var APPLIED_ON_ATTR = "AppliedOn";

	function _watchMapAttribute(ac, cn, node, id) {
		node[APPLIED_ON_ATTR] = 0;
		node[MODIFIED_ATTR] = true;

		ac.m_writer.changeNode(ac.widget.setupSettingsUrl).changeAttributeKeys(ac.widget.mapSettingId, xml.ATTR_STRINGMAP, csi.objectNew(node.$Name, ac.newValue));
	}

	var _Widget = declare([Widget, AttributeMapMixin], {
		setupSettingsUrl: null, // override this
		settingsUrl: null, // override this
		mapSettingId: null, // override this
		mapEntryNodeType: null, // override this
		destAttrIdAttr: null, // override this

		_getRootRequest: function(/*Node*/node) {
			// summary: query for necessary urls
			return comm.getNodeRequest([this.setupSettingsUrl, this.settingsUrl]);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: convert table entries into fake nodes
			var ql = this.inherited(arguments);

			// test for settingsUrl to protect against RequestGenerator use case
			if (ql.bMain && this.settingsUrl) {
				ql.createCustomStore = lang.hitch(this, function() {
					return new Nodes({
						cachingStore: this.cacheView,
						data: this._createRowNodes()
					});
				});
			}
			return ql;
		},

		_createRowNodes: function() {
			// summary: create a fake node for each table row
			var map = this._getMapSetting();

			// this can be null if using requestGenerator
			if (!map) {
				return;
			}

			var setUpMap = this._getMapSetupSetting();
			var appliedOn = this._getSetupSettings()[this.APPLIED_ON_ATTR];
			return _.map(this._getSourceAttributes(), function(sourceAttr) {
				var node = xml.nodeCreateClientNode(null, this.mapEntryNodeType, sourceAttr.getId());
				var destAttrId = map[sourceAttr.getId()] || "";
				var setUpDestAttrId = setUpMap[sourceAttr.getId()] || "";
				xml.nodeCreateClientAttr(node, this.destAttrIdAttr, xml.ATTR_STRING, setUpDestAttrId);
				// make the row yellow if the setup mapping is different from the published mapping
				xml.nodeCreateClientAttr(node, MODIFIED_ATTR, xml.ATTR_BOOLEAN, (setUpDestAttrId != destAttrId) || this._getModified(sourceAttr.getId()));
				// make the row white if it is not mapped
				xml.nodeCreateClientAttr(node, APPLIED_ON_ATTR, xml.ATTR_TIME, setUpDestAttrId ? appliedOn : 0);
				xml.nodeCreateClientAttr(node, "_type", xml.ATTR_STRING, this._getTypeForMatching(sourceAttr));
				return node;
			}, this);
		},

		_getModified: function(sourceAttrId) {
			// summary: placeholder for custom logic for modified
			return false;
		},

		_getSettings: function() {
			// summary: get the settings that hold the map
			return this.cacheView.getNode(this.settingsUrl);
		},

		_getSetupSettings: function() {
			// summary: get the setup settings that hold the map
			return this.cacheView.getNode(this.setupSettingsUrl);
		},

		_getMapSetting: function() {
			// summary: get the map itself from the settings
			return this._getSettings()?.[this.mapSettingId];
		},

		_getMapSetupSetting: function() {
			// summary: get the map itself from the setup settings
			return this._getSetupSettings()?.[this.mapSettingId];
		}
	});

	// call this before declaring the derived class
	_Widget.watchValueDropDown = function(mapEntryNodeType, destAttrIdAttr) {
		// summary: notice when an attribute's mapping changes and add a ChangeNode for it
		api.watchAttribute(mapEntryNodeType, destAttrIdAttr, _watchMapAttribute);
	};

	return _Widget;
});
